import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommercePerformanceEntityState} from "../reducers/ecommerce-performance.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePerformanceState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePerformance.entities[websiteId]);

export const getEcommercePerformance = (websiteId: number) => createSelector(getEcommercePerformanceState(websiteId),
  (state: IEcommercePerformanceEntityState) => {
    return state.data
  }
);

export const getEcommercePerformanceTotal = (websiteId: number) => createSelector(getEcommercePerformanceState(websiteId),
  (state: IEcommercePerformanceEntityState) => {
    if (!state?.data) return {};
      return {
        totalSales: state?.data.find(value => value?.stat === "revenue/total_sales"),
        netRevenue: state?.data.find(value => value?.stat === "revenue/net_revenue"),
        ordersCount: state?.data.find(value => value?.stat === "orders/orders_count"),
        itemsSold: state?.data.find(value => value?.stat === "products/items_sold"),
        totalTax: state?.data.find(value => value?.stat === "taxes/total_tax"),
        itemsSoldNumber: state?.data.find(value => value?.stat === "variations/items_sold")
    };
  }
);

export const getEcommercePerformanceLoading = (websiteId: number) => createSelector(getEcommercePerformanceState(websiteId),
  (state: IEcommercePerformanceEntityState) => state && state.loading
);

export const getEcommercePerformanceLoaded = (websiteId: number) => createSelector(getEcommercePerformanceState(websiteId),
  (state: IEcommercePerformanceEntityState) => {
      return state && state.loaded
  }
);
